<template>
    <v-flex xs12 md6
            class="study"
    >
        <h2 class="section-title">{{ $t('Обучение') }}</h2>
        <v-layout column class="study-block pa-4">
            <v-layout v-if="JSON.stringify(card) !== '{}'" row wrap
                      align-center
            >
                <v-flex class="d-block labels labels-mobile md8 sm6 xs12 mr-2">
                    <v-layout>
                        <labelTopic :class="classes">{{ $t(card_filter.label_text) }}</labelTopic>
                        <label-topic class="section-label--second">
                            {{ card.mandatory ? $t('Обязательный курс') : $t('Необязательный курс') }}
                        </label-topic>
                    </v-layout>
                </v-flex>
                <div v-if="card.date_start" class="text-sm-right text-xs-left"
                     :class="{'mt-4': $vuetify.breakpoint.xs, 'mt-0': $vuetify.breakpoint.smAndUp}"
                >{{ card.date_start }} - {{ card.date_end }}
                </div>
            </v-layout>
            <v-layout v-if="card.type === 'current' && card.series" row class="mt-3">
                <svg v-svg
                     symbol="series"
                     class="study__icon"
                     role="presentation"
                />
                <v-flex>
                    <span>{{ $t(card.series) }}</span>
                </v-flex>
            </v-layout>
            <v-flex d-flex align-center class="study__title xs7"> {{ card.title }}</v-flex>
            <v-flex v-if="card.type === 'current'" class="xs1">
                <svg v-svg
                     symbol="hourglass"
                     size="93 88"
                     class="study__icon"
                     role="presentation"
                />
                <span class="text-uppercase">{{ attempts }}</span>
            </v-flex>
            <v-layout align-center xs3 wrap>
                <router-link :class="{'layout mb-2': $vuetify.breakpoint.xs}"
                             :to="{name: (JSON.stringify(card) !== '{}') ? 'course_content' : 'study', params: {id: card.id, card_number: 0}}"
                >
                    <buttonWhite class="btn--bd-white-2 flex xs12">{{ $t(text_card) }}</buttonWhite>
                </router-link>
                <v-layout v-if="JSON.stringify(card) !== '{}'">
                    <v-flex
                        v-if="if_course_completed"
                        d-flex class="justify-end mx-3"
                        v-html="$t('Результат {lineBreak} итогового теста {lineBreak} {points} из {total}', {
                            'lineBreak': '<br>',
                            'points': card.points_earned_test,
                            'total': card.points_total_test,
                        })"
                    />
                    <v-flex
                        v-else
                        d-flex class="justify-end mx-3"
                        v-html="$t('Пройдено разделов {lineBreak} {lessonsPassed} из {lessonsTotal}', {
                            'lineBreak': '<br>',
                            'lessonsPassed': Number(card.lessons_passed),
                            'lessonsTotal': Number(card.lessons_total),
                        })"
                    />
                    <v-flex xs4 sm1 md2
                            mr-2
                    >
                        <v-progress-circular
                            :rotate="-90"
                            :size="64"
                            :width="6"
                            :value="if_course_completed ? percent(card.points_earned_test,card.points_total_test) : percent(card.lessons_passed,card.lessons_total)"
                            :color="if_course_completed ? '#9b9b9b' :'#44b69e'"
                        >
                            <span class="white--text">{{
                                if_course_completed ? percent(card.points_earned_test, card.points_total_test) : percent(card.lessons_passed, card.lessons_total)
                            }}%</span>
                        </v-progress-circular>
                    </v-flex>
                </v-layout>
            </v-layout>
        </v-layout>
    </v-flex>
</template>

<script>
import labelTopic from '@/components/ui/labels/label_topic.vue';
import buttonWhite from '@/components/ui/buttons/button_white';
import {mapGetters, mapActions} from 'vuex';
import api from '../../../api/index';

export default {
  components: {
    buttonWhite,
    labelTopic,
  },
  data() {
    return {
      main_cards : [],
      card       : {},
      card_filter: {},
    };
  },
  computed: {
    ...mapGetters('cards', ['cards', 'get_card_by_id', 'filters']),
    attempts() {
      let title;

      if (this.card.course_rest_time.indexOf('0') === 0) {
        title = this.$t('Просрочен');
      } else if (!this.card.course_rest_time.includes(this.$t('1 день'))) {
        title = this.$t('Осталось') + ' ' + this.card.course_rest_time;
      } else {
        title = this.$t('Остался') + ' ' + this.card.course_rest_time;
      }

      return title;
    },
    text_card() {
      let text = '';
      if (this.card.type === 'current') {
        text = 'Продолжить курс';
      } else if (this.card.type === 'newcourse') {
        text = 'Начать курс';
      } else if (this.card.type === 'finished') {
        if (this.card.test || this.card.points_required_test == 0) {
          text = 'Посмотреть курс';
        } else {
          text = 'Пройти тест';
        }
      }
      /*
                  if (this.card.lessons_passed == this.card.lessons_total && !this.card.expired) {
                    return 'Пройти тест';
                  } else {
                    return text;
                  }
            */
      return text;
    },
    if_course_completed() {
      // if (this.card.lessons_passed == this.card.lessons_total) {
      if (this.card.type == 'finished') {
        return true;
      } else {
        return false;
      }
    },
    classes: function() {
      const obj = {
        'newcourse': 'section-label--green',
        'finished' : 'section-label--grey',
        'current'  : 'section-label--white',
      };

      return obj[this.card.type];
    },
  },
  async mounted() {
    console.debug("mounted: employee_study");

    try {
      this.main_cards = await api.course.get_current_courses();
    } catch (err) {
      try {
        this.main_cards = await api.course.get_new_courses();
      } catch (err) {
        this.main_cards = await api.course.get_finished_courses();
      }
    }
    this.card = this.main_cards[0];
    this.card_filter = this.filters.find((item) => item.name == this.card.type);
  },
  methods: {
    ...mapActions('cards', ['get_courses']),
    percent: function(points, total) {
      if (points < total) {
        return Math.round((points / total) * 100);
      } else {
        return 100;
      }
    },
  },


};
</script>

